import { Car } from 'lucide-react';

interface AppBrandIconProps {
  size?: number;
  className?: string;
}

/** Ícone de marca Link Park — lucide:car (mesmo do favicon v1). */
export function AppBrandIcon({ size = 22, className }: AppBrandIconProps) {
  return <Car size={size} className={className} strokeWidth={2} aria-hidden />;
}
